import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { contactParentRejection } from '../../modules/contactParentRequired'
import { getSupplierContactListData } from './mockData'
import type { ISupplierContact } from '~/types/contact/models'

interface GetSupplierContactsResponse {
  data: ISupplierContact[]
}

async function getSupplierContacts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSupplierContactsResponse = {
    data: await getSupplierContactListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postSupplierContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return (
    (await contactParentRejection(req, res, ctx, {
      parentKey: 'supplier',
      modelName: 'SupplierContact',
    })) ?? addToEntityListData(req, res, ctx, getSupplierContactListData)
  )
}

const patchSupplierContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSupplierContactListData)
}

const deleteSupplierContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSupplierContactListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/suppliercontacts',
    handler: getSupplierContacts,
  },
  {
    method: 'post',
    path: '/api/suppliercontacts',
    handler: postSupplierContact,
  },
  {
    method: 'patch',
    path: '/api/suppliercontacts/:id',
    handler: patchSupplierContact,
  },
  {
    method: 'delete',
    path: '/api/suppliercontacts/:id',
    handler: deleteSupplierContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
